import React, { useState, useEffect, useRef } from 'react';
// Types pour suggestions IGN
interface IgnSuggestion {
  fulltext: any;
  label: string;
  houseNumber?: string;
  street?: string;
  postcode?: string;
  city?: string;
}
import Button from '../Button/Button';
import { handleSaveDraft, handleValidatedNext, handlePrint } from '../../utils/commonHandlers';
import { ReactComponent as PdfIcon } from '../../assets/icons/pdf.svg';
import RecapitulatifPDF from '../../pages/PDF/RecapPdf1Et2';

import './FormulaireAdministratif.css'
import Operation from '@/pages/Operation/Operation';

interface CMStepTwoProps {
  formData: {
    nomOperation: string;
    referenceInterne?: string;
    adresse: string;
    codePostal: string;
    ville: string;
    coordonneesMaitrise?: string;
    coordonneesMaitriseDOuvrage?: string;
    delaisConsultation: number;
    delaisFinOperation?: number;
    visitePreavis: boolean;
    conditionVisite?: string;
    besoin: string;
    dateDebutConsultation?: string;
    dateDebutOperation?: string;
    dateFinOperation?: string;
    datePrevisionelle?: string;
    operation: {
      visite: string | boolean;
      conditionVisite: string;
    };
  };
  setFormData?: (data: any) => void; // Optionnel pour le mode consultation
  onNext?: () => void; // Optionnel pour le mode consultation
  onPrevious?: () => void; // Optionnel pour le mode consultation
  viewMode?: boolean; // Nouveau paramètre pour le mode consultation
  hideBesoin?: boolean; // Option pour masquer la définition des besoins
  errors?: {
    nomOperation?: string;
    referenceInterne?: string;
    adresse?: string;
    codePostal?: string;
    ville?: string;
    conditionVisite?: string;
    besoin?: string;
  };
  commande?: {
    id: string;
    id_lot_departement: number;
    id_contrat: number;
    id_user: number | null;
    type_compte: string | null;
    id_entite: number;
    id_note_technique: number | null;
    id_status: number;
    nom: string | null;
    delais: number | null;
    adresse: string | null;
    cordonnee: string | null;
    modalite: string | null;
    visite: boolean | null;
    commentaire_visite: string | null;
    note_financiere: number | null;
    note_total: number | null;
    prix_total: number | null;
    created_at: string;
    updated_at: string;
    id_operation: number;
    expire_at: string | null;
    reponse: string | null; // Champ pour stocker la réponse technique
    operation: {
      id?: number;
      organisme_id?: number;
      organisme_nom: string;
      id_user?: number;
      id_lot_technique?: number;
      id_lot_departement?: number;
      type_compte?: string;
      adresse?: string;
      besoin?: string;
      cordonnee?: string | null;
      conditionVisite?: string | null;
      visite?: boolean;
      commentaire?: string | null;
      numero?: string;
      nom?: string;
      prix_total?: number | null;
      id_status?: number;
      reference?: string;
      delais?: number;
      echeance?: string | null;
      code_postal?: string;
      ville?: string;
      coordonnees_maitrise?: string;
      coordonnees_maitrise_ouvrage?: string;
      date_debut_operation?: string | null;
      date_fin_operation?: string | null;
      expire_at?: string;
      created_at?: string;
      updated_at?: string;
      id_commande?: number | null;
      facturation?: string;

      lot_technique?: {
        id: number;
        nom: string;
      };

      lot_departement?: {
        id: number;
        id_departement: number;
        created_at: string;
        updated_at: string;
        departement: {
          id: number;
          id_region: number;
          nom: string;
          created_at: string;
          updated_at: string;
        };
      };

      organisme?: {
        id: number;
        id_adresses: number;
        siret: string;
        nom: string;
        type: string;
        logo: string | null;
        logo_type: string | null;
        id_responsable_achat: number;
        created_at: string;
        updated_at: string;
        responsable_achat: {
          nom: string;
          prenom: string;
          email_contact: string;
          telephone: string;
          fonction: string;
        };
        adresse: {
          id: number;
          ville: string;
          code_postal: string;
          departement: string;
          pays: string;
          nom_voie: string;
          type_voie: string;
          numero_voie: string;
          arrondissement?: string;
          created_at: string;
          updated_at: string;
        };
      };

      acheteur?: {
        nom: string;
        prenom: string;
        email_contact: string;
        telephone: string;
        fonction: string;
      };
    }
    status: {
      id: number;
      action: boolean;
      nom: string;
      delai: number | null;
      type_compte: string;
    };
    articles?: any[];
    // Propriétés supplémentaires pour la présentation
    organisme_nom?: string;
    lot_technique?: {
      id: number;
      nom: string;
    };
    cree_par?: string;
  },
  operation: {
    id?: number;
    organisme_id?: number;
    organisme_nom: string;
    id_user?: number;
    id_lot_technique?: number;
    id_lot_departement?: number;
    type_compte?: string;
    adresse?: string;
    besoin?: string;
    cordonnee?: string | null;
    conditionVisite?: string | null;
    visite?: boolean;
    commentaire?: string | null;
    numero?: string;
    nom?: string;
    prix_total?: number | null;
    id_status?: number;
    reference?: string;
    delais?: number;
    echeance?: string | null;
    code_postal?: string;
    ville?: string;
    coordonnees_maitrise?: string;
    coordonnees_maitrise_ouvrage?: string;
    date_debut_operation?: string | null;
    date_fin_operation?: string | null;
    expire_at?: string;
    created_at?: string;
    updated_at?: string;
    id_commande?: number | null;
    facturation?: string;

    lot_technique?: {
      id: number;
      nom: string;
    };

    lot_departement?: {
      id: number;
      id_departement: number;
      created_at: string;
      updated_at: string;
      departement: {
        id: number;
        id_region: number;
        nom: string;
        created_at: string;
        updated_at: string;
      };
    };

    organisme?: {
      id: number;
      id_adresses: number;
      siret: string;
      nom: string;
      type: string;
      logo: string | null;
      logo_type: string | null;
      id_responsable_achat: number;
      created_at: string;
      updated_at: string;
      responsable_achat: {
        nom: string;
        prenom: string;
        email_contact: string;
        telephone: string;
        fonction: string;
      };
      adresse: {
        id: number;
        ville: string;
        code_postal: string;
        departement: string;
        pays: string;
        nom_voie: string;
        type_voie: string;
        numero_voie: string;
        arrondissement?: string;
        created_at: string;
        updated_at: string;
      };
    };

    acheteur?: {
      nom: string;
      prenom: string;
      email_contact: string;
      telephone: string;
      fonction: string;
    };
  }
}

const CMStepTwo: React.FC<CMStepTwoProps> = ({
  formData,
  setFormData,
  onNext,
  onPrevious,
  viewMode = false,
  hideBesoin = false,
  errors: externalErrors = {},
  commande,
  operation
}) => {
  const [internalErrors, setInternalErrors] = useState<{
    nomOperation?: string;
    adresse?: string;
    ville?: string;
    codePostal?: string;
    besoin?: string;
    conditionVisite?: string;
    referenceInterne?: string;
  }>({});

  // Ajout des états pour l'autocomplétion d'adresse
  const [adresseInput, setAdresseInput] = useState(formData.adresse || '');
  const [adresseSuggestions, setAdresseSuggestions] = useState<IgnSuggestion[]>([]);
  const debounceRef = useRef<NodeJS.Timeout | null>(null);

  // Utiliser les erreurs externes ou internes
  const errors = { ...internalErrors, ...externalErrors };

  const [isSaving, setIsSaving] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');

  // Effet pour l'autocomplétion d'adresse IGN
  useEffect(() => {
    if (adresseInput.trim().length < 3) {
      setAdresseSuggestions([]);
      return;
    }

    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(async () => {
      try {
        const response = await fetch(
          `https://data.geopf.fr/geocodage/completion?text=${encodeURIComponent(adresseInput)}&index=StreetAddress&limit=5`
        );
        if (response.ok) {
          const json = await response.json();
          if (json && json.results) {
            const suggestions: IgnSuggestion[] = json.results.map((item: any) => ({
              label: item.fulltext || '',
              houseNumber: item.housenumber || '',
              street: item.street || '',
              postcode: item.zipcode || '',
              city: item.city || ''
            }));
            setAdresseSuggestions(suggestions);
          }
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des suggestions d\'adresse:', error);
        setAdresseSuggestions([]);
      }
    }, 300);
  }, [adresseInput]);

  // Mise à jour du state local adresseInput lorsque formData.adresse change
  useEffect(() => {
    if (formData.adresse !== adresseInput) {
      setAdresseInput(formData.adresse || '');
    }
  }, [formData.adresse]);

  // Fonction pour sélectionner une adresse parmi les suggestions
  const handleSelectAdresse = (suggestion: IgnSuggestion) => {
    if (setFormData) {
      // Essayer plusieurs approches pour obtenir l'adresse correcte
      let adresseValue = '';

      // Essayer d'extraire la partie avant la virgule du label
      adresseValue = suggestion.label.includes(',')
        ? suggestion.label.split(',')[0].trim()
        : suggestion.label;


      // Mettre à jour les données du formulaire
      setFormData({
        ...formData,
        adresse: adresseValue,
        codePostal: suggestion.postcode || '',
        ville: suggestion.city || ''
      });

      // Mettre à jour le champ d'adresse
      setAdresseInput(adresseValue);

      // Effacer les erreurs liées à l'adresse
      if (errors.adresse || errors.codePostal || errors.ville) {
        setInternalErrors({
          ...internalErrors,
          adresse: undefined,
          codePostal: undefined,
          ville: undefined
        });
      }

      // Toujours masquer les suggestions après une sélection
      setAdresseSuggestions([]);
    }
  };

  // Fonction de validation
  const validateForm = () => {
    const newErrors: typeof internalErrors = {};

    if (!formData.nomOperation?.trim()) {
      newErrors.nomOperation = "Le nom de l'opération est obligatoire";
    }

    // if (!formData.referenceInterne?.trim()) {
    //   newErrors.referenceInterne = "Le numéro de référence interne est obligatoire";
    // }

    if (!formData.adresse?.trim()) {
      newErrors.adresse = "L'adresse est obligatoire";
    }

    if (!formData.codePostal?.trim()) {
      newErrors.codePostal = "Le code postal est obligatoire";
    }

    if (!formData.ville?.trim()) {
      newErrors.ville = "La ville est obligatoire";
    }

    if (formData.visitePreavis && !formData.conditionVisite?.trim()) {
      newErrors.conditionVisite = "Les conditions de visite sont obligatoires";
    }

    if (!hideBesoin && !formData.besoin?.trim()) {
      newErrors.besoin = "Le cahier des charges est obligatoire";
    }

    setInternalErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Calcule la date de fin de consultation
  const calculateEndConsultationDate = () => {
    const startDate = formData.dateDebutConsultation
      ? new Date(formData.dateDebutConsultation)
      : new Date();
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + (formData.delaisConsultation || 10));
    return endDate;
  };

  const finConsultationDate = calculateEndConsultationDate();
  const finConsultationStr = finConsultationDate.toISOString().split('T')[0];

  useEffect(() => {
    if (!setFormData || viewMode) return;

    const delaisConsult = formData.delaisConsultation || 10;
    const delaisOperation = formData.delaisFinOperation || 10;

    // Date de début de consultation
    const startConsult = formData.dateDebutConsultation
      ? new Date(formData.dateDebutConsultation)
      : new Date();

    // Date de fin de consultation
    const endConsult = new Date(startConsult);
    endConsult.setDate(startConsult.getDate() + delaisConsult);

    // Date de début de l'opération = lendemain de fin de consultation
    const startOperation = new Date(endConsult);
    startOperation.setDate(endConsult.getDate() + 1);

    // Date de fin de l'opération
    const endOperation = new Date(startOperation);
    endOperation.setDate(startOperation.getDate() + delaisOperation);

    // S'assurer que les dates sont au format ISO YYYY-MM-DD
    const formatDate = (date) => {
      return date.toISOString().split('T')[0];
    };

    // Utiliser un objet temporaire pour comparer avec prev
    const newDates = {
      dateDebutOperation: formatDate(startOperation),
      dateFinOperation: formatDate(endOperation),
    };

    // Ne mettre à jour que si les valeurs ont réellement changé
    setFormData(prev => {
      // Vérifier si les dates sont différentes de celles déjà dans prev
      const hasChanged =
        prev.dateDebutOperation !== newDates.dateDebutOperation ||
        prev.dateFinOperation !== newDates.dateFinOperation;

      // Si pas de changement, retourner prev sans modification
      if (!hasChanged) return prev;

      // Sinon, mettre à jour avec les nouvelles dates
      return {
        ...prev,
        ...newDates
      };
    });

    // Debug
    console.log("Dates calculées:", {
      dateDebutOperation: formatDate(startOperation),
      dateFinOperation: formatDate(endOperation)
    });

  }, [formData.dateDebutConsultation, formData.delaisConsultation, formData.delaisFinOperation, setFormData, viewMode]);

  return (
    <div className={`step-container ${viewMode ? 'view-mode' : ''}`}>
      <div className="form-row grid-3">
        {/* Ligne 1: Nom de l'opération, Référence interne */}
        <div className="form-group span-2">
          <label>Nom de l'opération {!viewMode && <span style={{ color: 'red' }}>*</span>}</label>
          {viewMode ? (
            <div className="input-inactif">{commande?.operation?.nom ?? operation?.nom}</div>
          ) : (
            <>
              <input
                type="text"
                value={formData.nomOperation || ''}
                onChange={(e) => {
                  if (setFormData) {
                    setFormData({ ...formData, nomOperation: e.target.value });
                    // Nettoyer l'erreur lors de la saisie
                    if (errors.nomOperation) {
                      setInternalErrors({ ...internalErrors, nomOperation: undefined });
                    }
                  }
                }}
                className={errors.nomOperation ? 'error' : ''}
                placeholder="Nom de l'opération"
              />
              {errors.nomOperation && <span className="error-message">{errors.nomOperation}</span>}
            </>
          )}
        </div>

        <div className="form-group">
          <label>N° de référence interne</label>
          {viewMode ? (
            <div className="input-inactif">{commande?.operation?.reference ? operation?.reference : '-'}</div>
          ) : (
            <>
              <input
                type="text"
                value={formData.referenceInterne || ''}
                onChange={(e) => {
                  if (setFormData) {
                    setFormData({ ...formData, referenceInterne: e.target.value });
                    if (errors.referenceInterne) {
                      setInternalErrors({ ...internalErrors, referenceInterne: undefined });
                    }
                  }
                }}
                className={errors.referenceInterne ? 'error' : ''}
                placeholder="N° de référence interne"
              />
              {errors.referenceInterne && <span className="error-message">{errors.referenceInterne}</span>}
            </>
          )}
        </div>

        {/* Ligne 2: Adresse, Code postal, Ville */}
        <div className="form-group">
          <label>Adresse de l'opération {!viewMode && <span style={{ color: 'red' }}>*</span>}</label>
          {viewMode ? (
            <div className="input-inactif">
              {
                commande?.operation?.organisme?.adresse.numero_voie} {commande?.operation?.organisme?.adresse.type_voie} {commande?.operation?.organisme?.adresse.nom_voie
                  ??
                  operation?.organisme?.adresse.numero_voie} {operation?.organisme?.adresse.type_voie} {operation?.organisme?.adresse.nom_voie
              }
            </div>
          ) : (
            <div className="autocomplete-container">
              <input
                type="text"
                id="adresse-autocomplete"
                value={adresseInput}
                onChange={(e) => {
                  setAdresseInput(e.target.value);
                  if (setFormData) {
                    setFormData({ ...formData, adresse: e.target.value });
                  }
                  if (errors.adresse) {
                    setInternalErrors({ ...internalErrors, adresse: undefined });
                  }
                }}
                className={errors.adresse ? 'error' : ''}
                placeholder="Saisissez la rue de l'opération" // Modifié
                autoComplete="off"
              />
              {adresseSuggestions.length > 0 && (
                <ul className="autocomplete-list" role="listbox">
                  {adresseSuggestions.map((suggestion, index) => (
                    <li
                      key={index}
                      role="option"
                      onClick={() => handleSelectAdresse(suggestion)}
                    >
                      {suggestion.label}
                    </li>
                  ))}
                </ul>
              )}
              {errors.adresse && <span className="error-message">{errors.adresse}</span>}
            </div>
          )}
        </div>

        <div className="form-group">
          <label>Code postal {!viewMode && <span style={{ color: 'red' }}>*</span>}</label>
          {viewMode ? (
            <div className="input-inactif">{commande?.operation?.organisme?.adresse.code_postal ?? operation?.organisme?.adresse.code_postal}</div>
          ) : (
            <>
              <input
                type="text"
                value={formData.codePostal || ''}
                onChange={(e) => {
                  let value = e.target.value.replace(/\D/g, '').slice(0, 5); // seulement chiffres, max 5
                  if (setFormData) {
                    setFormData({ ...formData, codePostal: value });
                  }
                  if (errors.codePostal) {
                    setInternalErrors({ ...internalErrors, codePostal: undefined });
                  }
                }}
                className={errors.codePostal ? 'error' : ''}
                placeholder="Code postal"
                inputMode="numeric"
                pattern="\d{5}"
                maxLength={5}
              />
              {errors.codePostal && <span className="error-message">{errors.codePostal}</span>}
            </>
          )}
        </div>

        <div className="form-group">
          <label>Ville {!viewMode && <span style={{ color: 'red' }}>*</span>}</label>
          {viewMode ? (
            <div className="input-inactif">{commande?.operation?.organisme?.adresse.ville ?? operation?.organisme?.adresse.ville}</div>
          ) : (
            <>
              <input
                type="text"
                value={formData.ville || ''}
                onChange={(e) => {
                  if (setFormData) {
                    setFormData({ ...formData, ville: e.target.value });
                  }
                  if (errors.ville) {
                    setInternalErrors({ ...internalErrors, ville: undefined });
                  }
                }}
                className={errors.ville ? 'error' : ''}
                placeholder="Ville"
              />
              {errors.ville && <span className="error-message">{errors.ville}</span>}
            </>
          )}
        </div>

        {/* Ligne 3: Coordonnées maîtrise d'ouvrage, Coordonnées maîtrise d'oeuvre */}
        <div className="form-group">
          <label>Facturation suivie par : <span className="form-subtitle">(Si existant)</span></label>
          {viewMode ? (
            <div className="input-inactif">{commande?.operation?.facturation ? operation?.facturation : '-'}</div>
          ) : (
            <input
              type="text"
              value={formData.coordonneesMaitriseDOuvrage || ''}
              onChange={(e) => setFormData && setFormData({ ...formData, coordonneesMaitriseDOuvrage: e.target.value })}
              placeholder="Affaire suivi par"
            />
          )}
        </div>

        <div className="form-group span-2">
          <label>Coordonnées de la maîtrise d'oeuvre <span className="form-subtitle">(Si existant)</span></label>
          {viewMode ? (
            <div className="input-inactif">{commande?.operation?.coordonnees_maitrise ? operation?.coordonnees_maitrise : '-'}</div>
          ) : (
            <input
              type="text"
              value={formData.coordonneesMaitrise || ''}
              onChange={(e) => setFormData && setFormData({ ...formData, coordonneesMaitrise: e.target.value })}
              placeholder="Coordonnées de la maîtrise d'oeuvre"
            />
          )}
        </div>

        {/* Ligne 4: Durée consultation, Date début consultation, Date fin consultation */}
        <div className="form-group">
          <label>Durée de la consultation <span className="form-subtitle">(Si ne respecte pas les 10 jours)</span></label>
          {viewMode ? (
            <div className="input-inactif">{commande?.operation?.echeance ? operation?.echeance : 10} jours</div>
          ) : (
            <input
              type="number"
              min={10}
              value={formData.delaisConsultation || 10}
              onChange={e => {
                const value = Math.max(10, Number(e.target.value));
                if (setFormData) {
                  setFormData({ ...formData, delaisConsultation: value });
                }
              }}
              placeholder="Nombre de jours"
            />
          )}
        </div>

        <div className="form-group">
          <label>Date prévisionnelle de début de consultation</label>
          {viewMode ? (
            <div className="input-inactif">
              {formData.dateDebutConsultation
                ? new Date(formData.dateDebutConsultation).toLocaleDateString('fr-FR')
                : new Date().toLocaleDateString('fr-FR')}
            </div>
          ) : (
            <input
              type="date"
              min={new Date().toISOString().split('T')[0]}
              value={formData.dateDebutConsultation || new Date().toISOString().split('T')[0]}
              onChange={(e) => setFormData && setFormData({
                ...formData,
                dateDebutConsultation: e.target.value
              })}
              className="date-input"
            />
          )}
        </div>

        <div className="form-group">
          <label>Date prévisionnelle de fin de consultation</label>
          <div className="input-inactif">
            {(() => {
              const startDate = formData.dateDebutConsultation
                ? new Date(formData.dateDebutConsultation)
                : new Date();
              const endDate = new Date(startDate);
              endDate.setDate(startDate.getDate() + formData.delaisConsultation);
              return endDate.toLocaleDateString('fr-FR');
            })()}
          </div>
        </div>

        {/* Ligne 5: Durée opération, Date début opération, Date fin opération */}
        <div className="form-group">
          <label>Durée d'exécution de l'opération<span className="form-subtitle">(Minimum 10 jours)</span></label>
          {viewMode ? (
            <div className="input-inactif">{commande?.operation?.delais ? operation?.delais : 10} jours</div>
          ) : (
            <input
              type="number"
              min={10}
              value={formData.delaisFinOperation || 10}
              onChange={e => {
                const value = Math.max(10, Number(e.target.value));
                if (setFormData) {
                  setFormData({ ...formData, delaisFinOperation: value });
                }
              }}
              placeholder="Nombre de jours"
            />
          )}
        </div>

        <div className="form-group">
          <label>Date prévisionnelle de début de l'opération</label>
          {viewMode ? (
            <div className="input-inactif">
              {
                commande?.operation?.date_debut_operation
                  ?
                  new Date(commande?.operation?.date_debut_operation).toLocaleDateString('fr-FR')
                  :
                  operation?.date_debut_operation
                    ?
                    new Date(operation?.date_debut_operation).toLocaleDateString('fr-FR')
                    :
                    ''
              }
            </div>
          ) : (
            <>
              <input
                type="date"
                min={finConsultationStr}
                value={formData.dateDebutOperation || finConsultationStr}
                onChange={(e) => setFormData && setFormData({
                  ...formData,
                  dateDebutOperation: e.target.value
                })}
                className="date-input"
              />
            </>
          )}
        </div>



        <div className="form-group">
          <label>Date prévisionnelle de fin de l'opération</label>
          {commande?.operation?.date_fin_operation ? (
            <div className="input-inactif">
              {new Date(commande?.operation?.date_fin_operation).toLocaleDateString('fr-FR')}
            </div>
          ) : (
            <div className="input-inactif">
              {(() => {
                const startDate = formData.dateDebutOperation
                  ? new Date(formData.dateDebutOperation)
                  : new Date();
                const endDate = new Date(startDate);
                endDate.setDate(startDate.getDate() + (formData.delaisFinOperation || 30));
                return endDate.toLocaleDateString('fr-FR');
              })()}
            </div>
          )}
        </div>

        <div className="form-group">
          <label>Date limite des candidatures</label>
          <div className="input-inactif">
            {operation?.expire_at ? new Date(operation.expire_at).toLocaleDateString('fr-FR') : 
             commande?.operation?.expire_at ? new Date(commande.operation.expire_at).toLocaleDateString('fr-FR') : 
             formData.datePrevisionelle && formData.datePrevisionelle !== "Pas précisé" ? 
             new Date(formData.datePrevisionelle).toLocaleDateString('fr-FR') : "Pas précisé"}
          </div>
        </div>

        {/* Ligne 6: Obligation visite préalable */}
        <div className="form-group">
          <label>Obligation de visiter préalablement à l'opération:</label>
          {viewMode ? (
            <div className="input-inactif">{formData.operation?.visite || (operation?.visite ? "Oui" : "Non")}</div>
          ) : (
            <div className="radio-options">
              <label>
                <input
                  type="radio"
                  name="visitePreavis"
                  checked={!formData.visitePreavis}
                  onChange={() => {
                    if (setFormData) {
                      setFormData({ ...formData, visitePreavis: false, conditionVisite: '' });
                      if (errors.conditionVisite) {
                        setInternalErrors({ ...internalErrors, conditionVisite: undefined });
                      }
                    }
                  }}
                />
                Non
              </label>
              <label>
                <input
                  type="radio"
                  name="visitePreavis"
                  checked={!!formData.visitePreavis}
                  onChange={() => setFormData && setFormData({ ...formData, visitePreavis: true })}
                />
                Oui
              </label>
            </div>
          )}
        </div>

        {(viewMode ? (formData.operation?.visite === "Oui" || operation?.visite === true) : formData.visitePreavis) && (
          <div className="form-group span-2">
            <label>Condition de la visite {!viewMode && <span style={{ color: 'red' }}>*</span>}</label>
            {viewMode ? (
              <div className="input-inactif">{formData.operation?.conditionVisite || operation?.conditionVisite || "Pas précisé"}</div>
            ) : (
              <>
                <input
                  type="text"
                  value={formData.conditionVisite || ''}
                  onChange={(e) => {
                    if (setFormData) {
                      setFormData({ ...formData, conditionVisite: e.target.value });
                      if (errors.conditionVisite) {
                        setInternalErrors({ ...internalErrors, conditionVisite: undefined });
                      }
                    }
                  }}
                  className={errors.conditionVisite ? 'error' : ''}
                  placeholder="Précisez les conditions de la visite"
                />
                {errors.conditionVisite && (
                  <span className="error-message">{errors.conditionVisite}</span>
                )}
              </>
            )}
          </div>
        )}

        {/* Définition du besoin (pleine largeur) */}
        {!hideBesoin && (
          <div className="form-group span-3">
            <label>Cahier des charges {!viewMode && <span style={{ color: 'red' }}>*</span>}</label>
            {viewMode ? (
              <div className="input-inactif definition-besoin">{formData.besoin}</div>
            ) : (
              <>
                <textarea
                  value={formData.besoin || ''}
                  onChange={(e) => {
                    if (setFormData) {
                      setFormData({ ...formData, besoin: e.target.value });
                      if (errors.besoin) {
                        setInternalErrors({ ...internalErrors, besoin: undefined });
                      }
                    }
                  }}
                  className={errors.besoin ? 'error' : ''}
                  placeholder="Cahier des charges"
                />
                {errors.besoin && <span className="error-message">{errors.besoin}</span>}
              </>
            )}
          </div>
        )}
      </div>

      {/* Boutons d'action */}
      {!viewMode && onNext && onPrevious && (
        <div className="action-section">
          <div className="action-buttons">
            <Button
              value="Imprimer"
              icon={<PdfIcon />}
              variant="secondary"
              onClick={() => handlePrint(
                <RecapitulatifPDF formData={formData} />,
                `marche-${formData.nomOperation || 'rapport'}.pdf`
              )}
            />
            <Button
              value={isSaving ? "Enregistrement..." : "Enregistrer en brouillon"}
              variant="secondary"
              onClick={() => handleSaveDraft(
                formData,
                '/api/marche-subsequent',
                setIsSaving,
                setSuccessMsg
              )}
              disabled={isSaving}
            />
            <Button value="Précédent" variant="secondary" onClick={onPrevious} />
            <Button
              value="Suivant"
              variant="primary"
              onClick={() => handleValidatedNext(validateForm, onNext)}
            />
            {isSaving && (
              <div style={{ textAlign: 'center', margin: '2rem 0' }}>
                <div className="loader" />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CMStepTwo;